import Details from '../classes/Details';

import '../../sass/blocks/notes-dropdown.scss';

(() => {
    const $notesDropdowns = document.querySelectorAll('.notes-dropdown');

    if (!$notesDropdowns) return;

    $notesDropdowns.forEach($notesDropdown => {
        const $dropdown = $notesDropdown.querySelector('.notes-dropdown__dropdown');

        const initServicesDetails = () => {
            if (!$dropdown) return;

            new Details($dropdown);
        };

        initServicesDetails();
    })
})();
